<div class='portal-data-element-list-indicator-element-container-display'>
  <ng-content></ng-content>
</div>
